function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  filter: "url(#purse_svg__filter0_d)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20.52 5.718a1.041 1.041 0 00-1.42-.38L11 10h12l-2.48-4.282z",
  fill: "url(#purse_svg__paint0_linear)"
}), /*#__PURE__*/React.createElement("rect", {
  x: 6.801,
  y: 10,
  width: 20.4,
  height: 15.6,
  rx: 2,
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.2 17.8a2.4 2.4 0 012.4-2.4h3.6v4.8h-3.6a2.4 2.4 0 01-2.4-2.4z",
  fill: "url(#purse_svg__paint1_linear)"
}), /*#__PURE__*/React.createElement("rect", {
  x: 22.402,
  y: 16.6,
  width: 2.4,
  height: 2.4,
  rx: 1.2,
  fill: "#fff"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "purse_svg__paint0_linear",
  x1: 13.25,
  y1: 5.2,
  x2: 20.675,
  y2: 9.445,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#89A6BE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.79,
  stopColor: "#68869F"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "purse_svg__paint1_linear",
  x1: 22.324,
  y1: 15.4,
  x2: 26.878,
  y2: 16.702,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#89A6BE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.79,
  stopColor: "#68869F"
})), /*#__PURE__*/React.createElement("filter", {
  id: "purse_svg__filter0_d",
  x: -1,
  y: -1,
  width: 36,
  height: 36,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  "in": "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.237656 0 0 0 0 0.293125 0 0 0 0 0.3375 0 0 0 0.08 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  "in": "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})));

var SvgPurse = function SvgPurse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 33,
    fill: "none"
  }, props), _ref, _ref2);
};

export default SvgPurse;